/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-DUAqv8gi.js";
import { t } from "./css-build-DcREbovZ.js";
import { t as n } from "./decorateMetadata-BXz2gmG4.js";
import { t as r } from "./decorate-C_HUHFGG.js";
import { LitElement as i, html as a, svg as o } from "lit";
import { customElement as s, property as c, query as l } from "lit/decorators.js";
// \0lit-plugin:css-sheet:./src/elements/spinner/spinner.css.js
var u = t("@keyframes spin{0%{stroke-dashoffset:240px}to{stroke-dashoffset:40px}}@keyframes rotate{to{transform:rotate(360deg)}}:host{color:var(--spinner-color,var(--color-highlight,var(--primary)));will-change:opacity;width:3em;height:3em;transition:opacity .3s;display:block;position:relative}:host(:not([active])){opacity:0}svg{width:100%;height:100%}circle{fill:none;stroke:currentColor;stroke-linecap:round;stroke-width:10px;stroke-dasharray:252;transform-origin:50%;will-change:transform}circle.spinning{animation:1.5s cubic-bezier(.44,.22,.64,.86) infinite alternate spin,1.2s linear infinite rotate}"), d = class extends e(i) {
	constructor(...e) {
		super(...e), this.styles = u, this.active = !1;
	}
	updated(e) {
		super.updated(e), clearTimeout(this._stopTimeout), e.has("active") && (this.active ? this._circle.classList.add("spinning") : this._stopTimeout = window.setTimeout(() => this._circle.classList.remove("spinning"), 300));
	}
	render() {
		return a`
            ${o`
                <svg viewBox="0 0 100 100">
                    <circle cx="50" cy="50" r="40" />
                </svg>
            `}
        `;
	}
};
r([c({
	reflect: !0,
	type: Boolean
}), n("design:type", Object)], d.prototype, "active", void 0), r([l("circle"), n("design:type", typeof SVGCircleElement > "u" ? Object : SVGCircleElement)], d.prototype, "_circle", void 0), d = r([s("ptc-ui-spinner")], d);
var f = d;
export { f as n, d as t };

//# sourceMappingURL=spinner-Bh3xaPEQ.js.map